import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
          <g>
            <path d="M0 0H24V24H0z" />
            <path
              fill={props.fill || "#818c99"}
              fillRule="nonzero"
              d="M6.326 6c-.75 0-1.37.62-1.37 1.37v7.434c0 .75.62 1.37 1.37 1.37h11.348c.75 0 1.37-.62 1.37-1.37V7.37c0-.75-.62-1.37-1.37-1.37H6.326zm0 1.174h11.348c.115 0 .196.08.196.196v7.434c0 .116-.08.196-.196.196H6.326c-.115 0-.196-.08-.196-.196V7.37c0-.116.08-.196.196-.196zm-2.348 9.391c-.211-.003-.408.108-.515.291-.107.183-.107.41 0 .592.107.183.304.294.515.291h16.044c.211.003.408-.108.515-.29.107-.184.107-.41 0-.593s-.304-.294-.515-.29H3.978z"
            />
          </g>
        </g>
      </svg>
    </>
  );
};
